import { FC } from 'react';
import {
  Stack,
  Tooltip,
  Box,
  Typography,
  Divider,
  ListItemText,
  MenuList,
  MenuItem,
  ListItemIcon,
  IconButton,
} from '@mui/material';
import { Close, Favorite, HeartBroken, MoreVertTwoTone } from '@mui/icons-material';

import { IconButtonDropdown } from '@cvt/components/ButtonDropdown';

import { useUniversityCrud } from '../hooks/useUniversityCrud';

export const UniversityOptionsScheduled: FC<Universities.University> = university => {

  return (
    <Stack direction="row" spacing={1}>
      <UniversityOptionsMore {...university} />
    </Stack>
  );
};

export const UniversityOptionsMore: FC<Universities.University> = university => {

  const { likeUniversity, unlikeUniversity, ignoreUniversity } = useUniversityCrud();

  const optionsDisabled = [likeUniversity.isPending, unlikeUniversity.isPending, ignoreUniversity.isPending].some(value => value); 

  return (
    <Box color="grey.500">
      <Tooltip title="More">
        <IconButtonDropdown
          buttonProps={{
            color: 'inherit',
          }}
          content={({ closeDropdown }) => (
            <Box>
              <Box bgcolor="secondary.light" px={2} py={1}>
                <Typography variant="h3">Options</Typography>
              </Box>
              <Divider/>
              <MenuList>
                {university.match.isFavourite ? (
                  <MenuItem onClick={() => [unlikeUniversity.mutateAsync(university.id), closeDropdown()]} disabled={optionsDisabled}>
                    <ListItemIcon>
                      <HeartBroken fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Unfavourite</ListItemText>
                  </MenuItem>
                ) : (
                  <MenuItem onClick={() => [likeUniversity.mutateAsync(university.id), closeDropdown()]} disabled={optionsDisabled}>
                    <ListItemIcon>
                      <Favorite fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Favorite</ListItemText>
                  </MenuItem>
                )}
                <MenuItem onClick={() => [ignoreUniversity.mutateAsync(university.id), closeDropdown()]} disabled={optionsDisabled}>
                  <ListItemIcon>
                    <Close fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Not interested</ListItemText>
                </MenuItem>
              </MenuList>
            </Box>
          )}
        >
          <MoreVertTwoTone/>
        </IconButtonDropdown>
      </Tooltip>
    </Box>
  );
};

export const UniversityOptions: FC<Universities.University> = university => {
  const { likeUniversity, unlikeUniversity, ignoreUniversity } = useUniversityCrud();

  const optionsDisabled = [likeUniversity.isPending, unlikeUniversity.isPending, ignoreUniversity.isPending].some(value => value); 

  return (
    <>
      {university.match.isFavourite && (
        <IconButton onClick={() => unlikeUniversity.mutateAsync(university.id)} color="error" disabled={optionsDisabled}>
          <Favorite fontSize="small" />
        </IconButton>
      )}
      <UniversityOptionsMore {...university} />
    </>
  );
};
